import React, { useContext, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"

import { AppContext } from "../contexts/AppContext"
import path from "../utils/pathSettings"
import Logo from "../media/Logo-AEGISMedicalCare.png"
import LogoIHSAN from "../media/Logo-IHSAN.png"
import CurrentDatetime from "./Component-CurrentDatetime";
import HeaderNav from "./Component-HeaderNav";
import HeaderProfile from "./Component-HeaderProfile";

const HeaderApp = () => {
    const { appState } = useContext(AppContext)
    const location = useLocation()

    useEffect(() => {
        window.scrollTo({ top: 0 })
    }, [location])

    // Decide which logo to use based on the current hostname
    let logoSrc = Logo;
    // Example: use a different logo for a specific hostname
    // import SpecialLogo from "../media/SpecialLogo.png"
    if (window.location.hostname === "ircs.mtfa.noggin.ai") {
        // logoSrc = SpecialLogo;
        logoSrc = LogoIHSAN; // fallback, replace with your actual alternate logo
    }

    if (appState.validLogin === false || location.pathname === "/login" || location.pathname === "/settings/centre" || location.pathname === "/forgotpassword") {
        return ("")
    } else {
        return (
            <div className="header">
                <div className="header-content">
                    <div className="left">
                        <HeaderNav view="mobile" />
                        <Link to={path("dashboard")} className="item">
                            <img src={logoSrc} alt="Logo" style={{ maxHeight: 50}}/>
                        </Link>
                        <HeaderNav view="desktop" />
                        <CurrentDatetime />
                    </div>
                    <div className="right">
                        <HeaderProfile />
                    </div>
                </div>
            </div>
        );
    }
};

export default HeaderApp
